import React from "react";

function ExportIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 10.75V16.75C15.75 17.2804 15.5393 17.7891 15.1642 18.1642C14.7891 18.5393 14.2804 18.75 13.75 18.75H2.75C2.21957 18.75 1.71086 18.5393 1.33579 18.1642C0.960714 17.7891 0.75 17.2804 0.75 16.75V5.75C0.75 5.21957 0.960714 4.71086 1.33579 4.33579C1.71086 3.96071 2.21957 3.75 2.75 3.75H8.75M18.75 6.75V0.75H12.75M18.75 0.75L7.75 11.75"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ExportIcon;
